import api from "src/services/api";
import { defaultFeatureSwitches, FeatureSwitches } from "src/config/featureSwitches";

const fromApi = (data: any): FeatureSwitches => {
  return {
    sinaGestionar: data?.sina_gestionar ?? defaultFeatureSwitches.sinaGestionar,
    notificaciones: data?.notificaciones ?? defaultFeatureSwitches.notificaciones,
    passkey: data?.passkey ?? defaultFeatureSwitches.passkey,
    homeKpis: data?.home_kpis ?? defaultFeatureSwitches.homeKpis,
    climaOrganizacional: data?.clima_organizacional ?? defaultFeatureSwitches.climaOrganizacional,
  };
};

const toApi = (switches: FeatureSwitches) => ({
  sina_gestionar: switches.sinaGestionar,
  notificaciones: switches.notificaciones,
  passkey: switches.passkey,
  home_kpis: switches.homeKpis,
  clima_organizacional: switches.climaOrganizacional,
});

export const obtenerFeatureSwitches = async (): Promise<FeatureSwitches> => {
  const { data } = await api.get<{ switches?: any }>("inicio/feature-switches");
  return fromApi(data?.switches || {});
};

export const actualizarFeatureSwitches = async (
  switches: FeatureSwitches
): Promise<FeatureSwitches> => {
  const { data } = await api.put<{ switches?: any }>("inicio/feature-switches", {
    switches: toApi(switches),
  });
  return fromApi(data?.switches || {});
};
